import React from 'react';
import useCcWebviewUtilsHelper from '@di-shared/features/common/useCcWebviewUtilsHelper';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';

export interface HeaderBackButtonProps {
  onClick?(): void;
}

function HeaderBackButton({onClick}: HeaderBackButtonProps) {
  const {t} = useInferableTranslation();
  const {backOrClose} = useCcWebviewUtilsHelper();

  return (
    <button
      type="button"
      className="btn btn_ic"
      aria-label={t('ctn_di_backwards')}
      onClick={onClick || (() => backOrClose())}
    >
      <span
        className="ic ic_arrow_back_24px"
        aria-hidden="true"
      />
    </button>
  );
}

export default HeaderBackButton;
